import * as React from 'react';
import classNames from 'classnames';
import './Breadcrumb.scss';

export interface IBreadcrumbProps {
  className?: string;
  children?: any;
}

const Breadcrumb = ({ className, children }: IBreadcrumbProps) => (
  <div className={classNames('breadcrumb', className)}>
    <ul>{children}</ul>
  </div>
);

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/index.tsx